export default "__VITE_ASSET__Ds5V0pZ9__"